const sectionTemplateStatus = {
    DRAFT : 0,

    IN_PRODUCTION : 1

};

angular.module('gw-um-j2js')
    .constant('sectionTemplateStatus', sectionTemplateStatus);